import { Outlet, useLocation } from "react-router-dom";
import "./App.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import {
  BusinessState,
  getBusinessEscrow,
  getBusinessInfo,
  getBusinessSubscription,
  getBusinessess,
} from "redux-context/business";
import { identifyUser, initializeMixpanel, resetIdentity } from "analytics";
import { autenticado } from "helpers/auth-functions";
import { getLoggedUserInfo, UserState } from "redux-context/user";
import { getPendingCollabsCount } from "redux-context/collabs";
import * as Sentry from "@sentry/react";
import { sseService } from "services/SSEStream";
import { getAllChats, setUnreadMessageCount } from "redux-context/chat";
import { DomainState, getDomainMetadata } from "redux-context/domain";
import { FacebookSDKLoader } from "helpers/facebook-auth";
import StorageListener from "components/storage-listener/StorageListener";

// import * as rdd from "react-device-detect";

// (rdd as any).isMobile = true;
// (rdd as any).isDesktop = false;

const { REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENV } = process.env;

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    environment: REACT_APP_SENTRY_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

function App() {
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const { loading, loggedUser } = useSelector((state: UserState) => state.user);
  const { business } = useSelector((state: BusinessState) => state.business);

  const newUnreadMessageSubscribeRef = useRef<() => void>();
  const businessId = localStorage.getItem("businessId");

  const { metadata } = useSelector((state: DomainState) => state.domain);
  const isAdminUser = loggedUser?.email?.endsWith(`@${metadata?.domain}`);

  useEffect(() => {
    newUnreadMessageSubscribeRef.current = sseService.subscribe(
      isAdminUser ? "superchat/total-unread-count" : "chat/total-unread-count",
      (event) => {
        const unreadCount = JSON.parse(event.data) as number;
        dispatch(setUnreadMessageCount(unreadCount));
      },
    );

    return () => {
      newUnreadMessageSubscribeRef.current?.();
    };
  }, [dispatch, businessId, isAdminUser]);

  useEffect(() => {
    if (autenticado() && loading) {
      dispatch(getLoggedUserInfo());
    }
  }, [dispatch, loading]);

  useEffect(() => {
    if (!loading) {
      dispatch(getBusinessess());
      dispatch(getBusinessInfo());
      dispatch(getPendingCollabsCount());
      dispatch(getAllChats({ countOnly: true }));
    }
  }, [dispatch, businessId, loading]);

  useEffect(() => {
    dispatch(getBusinessSubscription());
    dispatch(getBusinessEscrow());
    dispatch(getPendingCollabsCount());
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(getDomainMetadata());
  }, [dispatch]);

  useEffect(() => {
    console.log("Initializing Mixpanel");
    initializeMixpanel();
  }, []);

  useEffect(() => {
    console.log("object");
    if (loading) {
      return;
    }

    if (!loggedUser?.id) {
      resetIdentity();
      return;
    }

    identifyUser(loggedUser.id, {
      user_email: loggedUser?.email ?? null,
      business_id: business?._id ?? null,
    });
  }, [loading, loggedUser?.id, loggedUser?.email, business?._id]);

  return (
    <>
      <FacebookSDKLoader />
      <StorageListener />
      <Outlet />
    </>
  );
}

export default App;
